import { mapStocksStockItemsToFlatStockItems } from '../entity';
import { useStockItemsQuery } from '../queries';
import { AddSaleItemStockAllowanceType } from './components/procedure-sales-form-dialog';
import { AddProcedureStockAllowanceType } from './entity';

export const useEditableAndReadonlyStockAllowances = (
  stockAllowances: AddProcedureStockAllowanceType | AddSaleItemStockAllowanceType | undefined,
) => {
  const { data: stocksWithStockItems } = useStockItemsQuery(undefined);
  const stockItems = mapStocksStockItemsToFlatStockItems(stocksWithStockItems);

  if (!stockItems?.length) {
    return { editableAllowances: [], readonlyAllowances: stockAllowances ?? [] };
  }

  const stockItemIds = new Set(stockItems.map(item => item.id));

  const editableAllowances =
    stockAllowances?.filter(stockAllowance => stockItemIds.has(stockAllowance.stockItemId)) || [];
  const readonlyAllowances =
    stockAllowances?.filter(stockAllowance => !stockItemIds.has(stockAllowance.stockItemId)) || [];

  return { editableAllowances, readonlyAllowances };
};
